import { reduceAndSort } from 'modules/taboola-common-frontend-modules/utils/objectUtils';
import { COMPONENT_STATUS } from 'services/constants';

export const getActiveItemsList = listObject =>
    reduceAndSort(listObject).filter(item => item.status === COMPONENT_STATUS.ACTIVE);
